"use client";

import { useSpineSlice } from "@/components/site/motion/useSpineSlice";

export function ProgressLines() {
  useSpineSlice((m) => m.spine!.buildProgress());
  return (
    <div className="progress_lines f s-b _tempHide" aria-hidden="true">
      <div className="progress_line f a-c j-c">
        <span className="line_shape">
          <i className="full_bg"></i>{" "}
        </span>
        <i className="full_bg"></i>
      </div>
      <div className="progress_line f a-c j-c">
        <span className="line_shape">
          <i className="full_bg"></i>{" "}
        </span>
        <i className="full_bg"></i>
      </div>
    </div>
  );
}
